import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  BackResponse,
  BackResponseFailure,
  RiskCarrier,
} from '@savgroup-front-common/types';

import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/riskCarrier`;

async function getFileRiskCarrier({
  fileId,
}: {
  fileId: string;
}): Promise<BackResponse<RiskCarrier> | BackResponseFailure> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    const response = await apiCall<BackResponse<RiskCarrier>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return { failure: true, errors: (exception as any).errors };
  }
}

export default getFileRiskCarrier;
